import { ReactNode } from 'react';

import { Card, Row } from 'components/Blocks';

interface ContentCardProps {
  children?: never;
  header: ReactNode;
  content: ReactNode;
}

export function ContentCard({ content, header }: ContentCardProps): JSX.Element {
  return (
    <Card flow="column" className="p-0" fullWidth>
      <Row
        className="rounded-t-md bg-primary/65 px-7 py-4 font-semibold text-primary-foreground"
        fullWidth
      >
        {header}
      </Row>

      <Row className="rounded-b-md px-6 py-4" fullWidth>
        {content}
      </Row>
    </Card>
  );
}
